import { idiomaAtual, t } from '../../i18n/idioma';
import type { Feito } from './comum';
import type { Secao } from './Paleta';

interface Props {
  totalOnline: number | null;
  naSala: number | null;
  mobs: number;
  hora: string;
  eventoAoVivo: string | null;
  registro: readonly Feito[];
  onSecao(s: Secao): void;
  onBuscar(): void;
}

/**
 * O Painel: só contadores (nunca a lista do shard — techspec-gm-menu §02), os atalhos de sempre e as últimas ações.
 */
export function PainelGm({ totalOnline, naSala, mobs, hora, eventoAoVivo, registro, onSecao, onBuscar }: Props) {
  const idioma = idiomaAtual();
  const kpi = (valor: string, rotulo: string, acao: string, ir: () => void) => (
    <div className="gmx-card gmx-kpi">
      <b>{valor}</b>
      <span>{rotulo}</span>
      <button type="button" onClick={ir}>{acao} →</button>
    </div>
  );
  const rapidas: readonly { titulo: string; sub: string; fazer(): void }[] = [
    { titulo: t('gm.x.painel.rBuscar'), sub: t('gm.x.painel.rBuscarSub'), fazer: onBuscar },
    { titulo: t('gm.x.painel.rHora'), sub: t('gm.x.painel.rHoraSub'), fazer: () => onSecao('mundo') },
    { titulo: t('gm.x.painel.rItem'), sub: t('gm.x.painel.rItemSub'), fazer: () => onSecao('itens') },
    { titulo: t('gm.x.painel.rEvento'), sub: t('gm.x.painel.rEventoSub'), fazer: () => onSecao('eventos') }
  ];
  const ultimas = registro.slice(0, 5);

  return (
    <>
      <div className="gmx-grade gmx-g4">
        {kpi(totalOnline == null ? '—' : totalOnline.toLocaleString(idioma), t('gm.x.painel.online'), t('gm.x.painel.buscar'), onBuscar)}
        {kpi(naSala == null ? '—' : naSala.toLocaleString(idioma), t('gm.x.painel.naSala'), t('gm.x.painel.verSala'), () => onSecao('jogadores'))}
        {kpi(String(mobs), t('gm.x.painel.inimigos'), t('gm.x.painel.gerenciar'), () => onSecao('mundo'))}
        {kpi(hora, eventoAoVivo ?? t('gm.x.painel.semEvento'), t('gm.x.painel.verEventos'), () => onSecao('eventos'))}
      </div>

      <p className="gmx-h" style={{ marginTop: 14 }}>{t('gm.x.painel.rapidas')}</p>
      <div className="gmx-rapidas">
        {rapidas.map(r => (
          <button key={r.titulo} type="button" className="gmx-rapida" onClick={r.fazer}>
            <b>{r.titulo}</b>
            <span>{r.sub}</span>
          </button>
        ))}
      </div>

      <div className="gmx-card" style={{ marginTop: 14 }}>
        <div className="gmx-linha">
          <p className="gmx-h" style={{ margin: 0 }}>{t('gm.x.painel.ultimas')}</p>
          <span className="gmx-esp" />
          {registro.length > 0 && <button type="button" className="btn btn--tiny" onClick={() => onSecao('registro')}>{t('gm.x.painel.verRegistro')}</button>}
        </div>
        {ultimas.length === 0
          ? <p className="gmx-meta" style={{ marginTop: 8 }}>{t('gm.x.reg.vazio')}</p>
          : (
            <ul className="gmx-reg" style={{ marginTop: 6 }}>
              {ultimas.map(f => (
                <li key={f.id}><time>{f.hora}</time><span><i>{f.cat}</i>{f.txt}</span><span /></li>
              ))}
            </ul>
          )}
      </div>
    </>
  );
}
